<template>
    <div>
        <dash-board :filter-stadium="stadium" />
    </div>
</template>

<script>
import { mapState } from 'vuex'
import dashBoard from '../pitches/dashboard'

export default {
  name: 'tabPitches',
  components: {
    dashBoard
  },
  props: {
    editExternal: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data () {
    return {
      modal: false,
      edit: true,
      action: 'create'
    }
  },
  computed: {
    ...mapState({
      stadium: state => state.stadiums.stadiumSelected,
      listPitches: state => state.pitches.listPitches,
      listCountries: state => state.countries.list,
      listProvinces: state => state.provinces.list,
      listTowns: state => state.cities.list,
      listUser: state => state.users.listaUsers,
      listLanguages: state => state.languages.listLanguages,
      pitch: state => state.pitches.pitchSelected,
      stadiumSelected: state => state.pitches.stadiumSelect
    }),
    complexPitch () {
      let result = this.pitch
      result.stadiumId = this.stadiumSelected
      return result
    }
  },
  methods: {
    create () {
      this.action = 'create'
      this.edit = true
      this.modal = true
    },
    update () {
      this.action = 'update'
      this.edit = true
      this.modal = true
    },
    remove () {
      this.action = 'remove'
      this.edit = false
      this.modal = true
    },
    close () {
      this.modal = false
      this.action = ''
    }
  }
}
</script>
